import { useSelector } from 'react-redux';

const useModalData = name => {
  const data = useSelector(state => state.utils.modalData[name]) || {};

  return data;
};

export default useModalData;
